/**
 * TanStack Query Configuration Constants
 * Standard stale time and cache time values for consistent query behavior
 */

/**
 * Query stale time configurations
 * Stale time determines how long query data is considered fresh
 */
export const QUERY_STALE_TIME = {
  /** 30 seconds - for real-time data that changes frequently */
  SHORT: 30 * 1000,
  /** 1 minute - for moderately dynamic data (default) */
  MEDIUM: 60 * 1000,
  /** 5 minutes - for relatively static data */
  LONG: 5 * 60 * 1000,
  /** 30 minutes - for rarely changing configuration data */
  VERY_LONG: 30 * 60 * 1000,
} as const;

/**
 * Query cache time configurations
 * Cache time determines how long unused query data stays in memory
 */
export const QUERY_CACHE_TIME = {
  /** 10 minutes - default cache retention */
  DEFAULT: 10 * 60 * 1000,
  /** 1 hour - for expensive queries or large datasets */
  LONG: 60 * 60 * 1000,
} as const;
